export const mensajesChat = {
  // NewConversationModal.vue — بدء محادثة جديدة عبر واتساب
  newConversation: {
    nameTooShort: "اكتب الاسم الذي تريد أن يتعرّف الناس عليك به.",
    saveNameError: "تعذّر حفظ الاسم التجاري.",
    started: "بدأت المحادثة.",
    sent: "تم إرسال الرسالة.",
    startError: "تعذّر بدء المحادثة.",
    titleConnect: "اربط حساب واتساب الخاص بك",
    titleName: "اسمك التجاري",
    titleNew: "محادثة جديدة",
    subtitleConnect: "ضروري لتتمكن من المراسلة أولاً",
    subtitleName: "هو الاسم الذي سيظهر للطرف الآخر كمُرسِل",
    subtitleNew: "راسل أي رقم عبر واتساب",
    close: "إغلاق",
    senderStripPre: "سيُرسَل باسم",
    change: "تغيير",
    connectBody:
      "لتراسل أولاً، يجب أن تصدر الرسالة من <strong>رقم واتساب بزنس الخاص بك</strong>. فمع رقم WACheckin المشترك سيرى الطرف الآخر هاتفاً ليس لك، ولن نتمكن من تقديمك باسمك التجاري.",
    connectItem1: "تراسل أي رقم، سواء كان لديه حجز أم لا",
    connectItem2: "يظهر اسمك التجاري كمُرسِل",
    connectItem3: "تصل الردود إلى صندوق الوارد نفسه",
    connectFoot: "يتم الربط مرة واحدة، من التكاملات ← واتساب.",
    previewLabel: "هكذا سيراها",
    previewGreeting: "مرحباً 👋",
    previewFromPre: "نراسلك من",
    previewFromPost: ".",
    previewCtaPre: "لدينا رسالة لك. أجب بـ",
    previewOk: "Ok",
    previewCtaPost: "وسنرسلها إليك.",
    fallbackBusiness: "عملك",
    nameLabel: "الاسم التجاري",
    namePlaceholder: "بيت الضيافة الريفي",
    nameHelp:
      "يُحفَظ في وكيل الذكاء الاصطناعي ← الحجوزات الجديدة، ويمكنك تغييره هناك أو هنا متى شئت.",
    recipientLabel: "المُستلِم",
    messageLabel: "الرسالة",
    messagePlaceholder: "اكتب رسالتك…",
    cancelSoft: "ليس الآن",
    cancel: "إلغاء",
    connectBtn: "ربط واتساب",
    continueBtn: "متابعة",
    sendBtn: "إرسال الرسالة",
  },

  // MessageTranslate.vue — ترجمة كل رسالة داخل فقاعات المحادثة
  translate: {
    // BarraTraduccion.vue — شريط مترجم المحادثة (تلقائي + معاينة)
    off: "الترجمة التلقائية متوقفة",
    on: "جارٍ الترجمة",
    turnOn: "ترجمة ما يصل ومعاينة ما تكتبه",
    turnOff: "إيقاف الترجمة التلقائية",
    guestWrites: "الضيف يكتب بـ{idioma}",
    nothingToDo: "لا شيء للترجمة: الضيف يكتب بـ{idioma}",
    youRead: "تقرأها بـ",
    willBeSentIn: "وما تكتبه سيُرسل بـ",
    pickOutgoing: "بأي لغة ستصله",
    theirs: "لغته",
    willArriveAs: "هكذا ستصله، بـ{idioma}:",
    sendIn: "إرسال بـ{idioma}",
    cancel: "إلغاء",
    discard: "تجاهل",
    enterSends: "Enter للإرسال",
    translating: "جارٍ الترجمة…",
    translate: "ترجمة",
    viewTranslation: "عرض الترجمة",
    viewOriginal: "عرض الأصل",
    translated: "مُترجَمة",
    copy: "نسخ",
    copied: "تم النسخ",
    error: "تعذّرت الترجمة. حاول مرة أخرى.",
  },

  // Phone.vue — معاينة روبوت المحادثة بنمط واتساب
  phone: {
    online: "متصل الآن",
    today: "اليوم",
    sampleQuestion: "ما موعد تسجيل الوصول؟",
    answerPlaceholder: "اكتب ردك هنا...",
    inputPlaceholder: "اكتب رسالة...",
  },

  // selectorTypeIframe.vue — محدِّد فترة الاشتراك
  billing: {
    selectPeriod: "اختر الفترة",
    selectPeriodHint: "اختر طريقة الدفع",
    monthly: "شهري",
    annual: "سنوي",
  },

  // GrupoDestinatarios.vue — escribir a un grupo de huéspedes
  grupo: {
    modeLabel: "إلى من تكتب",
    modeOne: "رسالة عادية",
    modeGroup: "رسالة جماعية",
    allOtas: "الكل",
    needsWhatsapp: "اربط واتساب لاستخدام هذه الوسيلة",
    connectNow: "اربطه",
    varsLabel: "متغيّر",
    vars: {
      nombre: "اسم النزيل",
      alojamiento: "اسم مكان الإقامة",
      entrada: "تاريخ الوصول",
      salida: "تاريخ المغادرة",
      codigo: "رمز الحجز",
    },
    remove: "إزالة",
    oneEach: "يستلمها كل نزيل مرة واحدة، عبر أول وسيلة متاحة.",
    noContact: "1 بدون وسيلة تواصل | {count} بدون وسيلة تواصل",
    otaLabel: "أي OTA",
    emoji: "إيموجي",
    attach: "إرفاق ملف",
    noFileOta: "الملف لا يمر عبر OTA",
    previewLabel: "هكذا ستُقرأ",
    fileTooBig: "«{name}» حجمه {size} ميغابايت والحد الأقصى في واتساب لهذا النوع هو {max} ميغابايت",
    fileNotAllowed: "لا تُقبل سوى الصور (JPG وPNG وGIF) وملفات PDF وفيديو MP4: واتساب لا يشغّل الصيغ الأخرى.",
    attachHint: "الصور وملفات PDF حتى 10 ميغابايت · فيديو MP4 حتى 15 ميغابايت",
    channelLabel: "عبر أي وسيلة",
    channels: { whatsapp: "واتساب", email: "البريد", ota: "OTA" },
    groupLabel: "أي نزلاء",
    groups: {
      alojados: "النزلاء الحاليون",
      entran_hoy: "يصلون اليوم",
      entran: "وصول قريب",
      salen: "يغادرون اليوم",
    },
    withinPre: "خلال",
    withinPost: "يوم | أيام",
    empty: "لا يوجد نزلاء في هذه المجموعة حاليًا.",
    reachOf: "من {total} سيستلمها | من {total} سيستلمونها",
    queuedSilently: "واحد لن يصله إشعار اليوم: كان لديه إشعار معلّق | {count} لن يصلهم إشعار اليوم: كان لديهم إشعار معلّق",
    noChannel: {
      whatsapp: "1 بدون هاتف | {count} بدون هاتف",
      email: "1 بدون بريد | {count} بدون بريد",
      ota: "1 بدون محادثة OTA | {count} بدون محادثة OTA",
    },
    billed: "محادثة واتساب واحدة محتسبة | {count} محادثات واتساب محتسبة",
    showList: "عرض المستلم | عرض {count} مستلمين",
    hideList: "إخفاء القائمة",
    noName: "بدون اسم",
    states: {
      directo: "وصل",
      plantilla: "دعوة",
      en_cola: "كان لديه معلّق",
      sin_telefono: "بدون هاتف",
      sin_correo: "بدون بريد",
      sin_hilo_ota: "بدون محادثة",
      sin_contacto: "بدون تواصل",
    },
    sending: "جارٍ الإرسال إلى نزيل واحد | جارٍ الإرسال إلى {count} نزلاء",
    sendGroup: "إرسال إلى نزيل واحد | إرسال إلى {count} نزلاء",
    historial: {
      providerId: "معرّف المزوّد. يُستخدم للبحث عن الرسالة في لوحة SES.",
      sentMeans: "«أُرسلت» تعني أن المزوّد قبِلها. أما أن يقرأها النزيل أو ألّا تذهب إلى البريد غير المرغوب فيه، فذلك خارج عن سيطرتنا.",
      estados: {
        enviando: "جارٍ الإرسال",
        enviado: "أُرسلت",
        en_cola: "في الانتظار",
        fallo: "لم تُرسل",
        sin_contacto: "بلا وسيلة تواصل",
      },
      title: "الإرسال الجماعي",
      subtitle: "ما أُرسل، وإلى من، وماذا حدث مع كل واحد",
      empty: "لم ترسل أي رسالة جماعية بعد.",
      error: "تعذّر تحميل السجل.",
      sentBy: "بواسطة {quien}",
      running: "جارٍ التنفيذ",
      back: "رجوع",
      messageLabel: "الرسالة",
      recipientsLabel: "المستلمون",
      colName: "النزيل",
      colVia: "الوسيلة",
      colDest: "إلى أين",
      colState: "النتيجة",
      openChat: "فتح",
      attachment: "مرفق: {nombre}",
      close: "إغلاق",
      reached: "{enviados} من {total}",
      noOne: "بلا اسم",
    },
  },
};
